export const UndoIcon = ({ isActive }: any) => {
  const finalColor = isActive ? "white" : "#0C172C";

  return (
    <svg width="24" height="24" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.19775 0.180664C2.95618 -0.0605657 2.55654 -0.0605223 2.31494 0.180664L0.181152 2.31445C-0.060435 2.55613 -0.0604878 2.9566 0.181152 3.19824L2.31494 5.33105C2.43992 5.45596 2.59807 5.51465 2.75635 5.51465C2.91463 5.51463 3.07278 5.45598 3.19775 5.33105C3.43937 5.08944 3.43928 4.68992 3.19775 4.44824L2.18115 3.43066H10.0063C11.9563 3.4307 13.5483 5.02273 13.5483 6.97266C13.5483 8.92263 11.9563 10.5146 10.0063 10.5146H3.33936C2.99781 10.5148 2.71436 10.7981 2.71436 11.1396C2.71447 11.4811 2.98956 11.7645 3.33936 11.7646H10.0063C12.648 11.7646 14.7983 9.6143 14.7983 6.97266C14.7983 4.33106 12.648 2.1807 10.0063 2.18066H2.08154L3.19775 1.06445C3.43942 0.822786 3.43942 0.422331 3.19775 0.180664Z"
        fill={finalColor}
      />
    </svg>
  );
};
